import React from "react";
import { useNavigate } from "react-router-dom";
import formSuccessIcon from "~/assets/form-success.svg";
import CustomeButton from "~/components/Button";
import "./TenantOnboardingSuccess.scss";

interface TenantOnboardingSuccessProps {
  tenantName: string;
  tenantId: string;
  onClose: () => void;
}

/**
 * Success message component for tenant onboarding
 * Displays centered success message with CTAs
 */
export const TenantOnboardingSuccess: React.FC<
  TenantOnboardingSuccessProps
> = ({ tenantName, tenantId, onClose }) => {
  const navigate = useNavigate();

  const handleViewTenant = () => {
    // GXM-1782: Pass state to bypass APIM cache and show creator in assigned users immediately
    navigate(`/tenants/${tenantId}`, { state: { refetchUsers: true } });
  };

  const handleCloseWizard = () => {
    onClose();
    navigate("/tenants");
  };

  return (
    <div className="tenant-onboarding-success">
      <div className="tenant-onboarding-success-content">
        <div className="tenant-onboarding-success-icon">
          <img src={formSuccessIcon} alt="Success" />
        </div>
        <h1 className="tenant-onboarding-success-title">
          Congrats, {tenantName} has been registered as Tenant
        </h1>
        <p className="tenant-onboarding-success-subtitle">
          Your new tenant has been created and it's now ready to be used
        </p>
        <div className="tenant-onboarding-success-actions">
          <CustomeButton
            label="View Tenant Profile"
            onClick={handleViewTenant}
            className="add-new-lsp"
          />
          <button
            type="button"
            className="cancel-btns"
            onClick={handleCloseWizard}
          >
            Close Wizard
          </button>
        </div>
      </div>
    </div>
  );
};
